(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torvani-sale-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('torvani-sale-bar')) {
    customElements.define('torvani-sale-bar', class extends HTMLElement {
      connectedCallback() {
        this.onScroll = () => this.toggleAttribute('data-away', window.scrollY > 8);
        this.onScroll();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.end = Date.parse(this.dataset.deadline || '');
        this.timer = this.querySelector('.tv-sale__timer');
        if (!Number.isFinite(this.end)) return;
        this.tick();
        if (this.end > Date.now()) this.interval = window.setInterval(() => this.tick(), 1000);
      }
      tick() {
        const remaining = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
        if (!remaining) {
          this.hidden = true;
          window.clearInterval(this.interval);
          return;
        }
        this.timer.hidden = false;
        const parts = {
          days: Math.floor(remaining / 86400),
          hours: Math.floor(remaining / 3600) % 24,
          minutes: Math.floor(remaining / 60) % 60,
          seconds: remaining % 60
        };
        Object.entries(parts).forEach(([unit, value]) => {
          this.querySelector('[data-' + unit + ']').textContent = unit === 'days' ? value : String(value).padStart(2, '0');
        });
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.clearInterval(this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
